import { render, staticRenderFns } from "./LiveRoom.vue?vue&type=template&id=e4f2c8f6&scoped=true"
import script from "./LiveRoom.vue?vue&type=script&lang=js"
export * from "./LiveRoom.vue?vue&type=script&lang=js"
import style0 from "./LiveRoom.vue?vue&type=style&index=0&id=e4f2c8f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f2c8f6",
  null
  
)

export default component.exports